import { BaseModel, PaginationDataModel, convertToArrayModels, convertToModel, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import type { PaginationData } from '~/shared/interfaces'
import ArticleCard from '../article-detail/ArticleCard'
import ArticleTagWithNewsCount from './ArticleTagWithNewsCount'

export default class ArticleQueryResult extends BaseModel {
  static override constructorName = 'ArticleQueryResult'

  items: ArticleCard[] = []
  pagination: PaginationData = new PaginationDataModel()
  'tags_with_news_count': ArticleTagWithNewsCount[] = []

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      this.items = convertToArrayModels(data.data, ArticleCard)

      this.pagination = convertToModel(data.meta, PaginationDataModel, this.pagination)

      this.tags_with_news_count = convertToArrayModels(data.tags_with_news_count, ArticleTagWithNewsCount)
    }
  }
}

registerModel(ArticleQueryResult)
